import AuthLayout from '@/pages/AuthLayout.vue';
import NotFound from '@/views/NotFoundPage.vue';

const Home = () => import(/* webpackChunkName: "pages" */ '@/pages/Home.vue');
const ThankYou = () => import(/* webpackChunkName: "pages" */ '@/pages/ThankYou.vue');

let thankYouPage = {
  path: '/thank-you',
  component: ThankYou,
  name: 'Thank You',
};

let authPages = {
  path: '/',
  component: AuthLayout,
  name: 'Authentication',
  children: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        noBodyBackground: true
      }
    },
    { path: '*', component: NotFound }
  ]
};

const routes = [
  authPages,
  thankYouPage
];

export default routes;
